import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import '../filters';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
  name: 'selectOfTree',
  components: {
    Treeselect
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    placeHolder: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      required: true
    },
    allowMultiSelect: {
      type: Boolean,
      default: false
    },
    parent: {
      type: Object,
      required: true
    },
    model: {
      type: String,
      required: true
    },
    changeSelection: {
      type: Boolean,
      default: false
    },
    changeSelectionFunc: {
      type: Function
    },
    elementPropertiesGroup: {
      type: String
    },
    elementPropertiesRowIndex: {
      type: Number
    },
    disableFuzzyMatching: {
      type: Boolean,
      default: true
    },
    showItemsCount: {
      type: Boolean,
      default: false
    },
    returnNode: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },
  data: function () {
    return {
      //selectedItems: []
      mod: '',
      titleWithItemsCount: ''
    }
  },
  created() {
    //this.manageList();

    if (this.changeSelection) {
      if (this.items.filter(a => a.selected).length > 0)
        this.mod = this.items.filter(a => a.selected)[0].id;
    } else {
      this.mod = this.getParentModel();// this.parent[this.model];
    }

    if (this.showItemsCount)
      this.titleWithItemsCount = this.title + '<span>' + this.items.length + '</span>';
  },
  computed: {

  },
  watch: {
    //selectedItems: {
    //  handler: function (val) {
    //    this.$store.commit('setSelectedElementType', { allowMultiSelect: this.allowMultiSelect, val: val });
    //  },
    //  deep: true
    //}
    mod: {
      handler: function (val) {
        if (val == undefined)
          this.setParentModel(val);
      },
      deep: true
    }
  },
  mounted() {
    this.$watch(
      () => {
        return this.items
      },
      (val) => {
        if (!this.changeSelection) {
          //this.mod = this.parent[this.model];
          this.mod = this.getParentModel();
        }
      }
    )
  },
  methods: {
    selectionChanges(node, instanceId) {
      if (this.changeSelection) {
        this.$emit('itemSelected', this.elementPropertiesGroup, this.elementPropertiesRowIndex, node)
        //for (var i = 0; i < this.items.length; i++) {
        //  this.items[i].selected = false;

        //  if (this.items[i].id == node.id) {
        //    this.items[i].selected = true;
        //    console.log('node', node);

        //    console.log('parent', this.parent.elementProperties.properties);
        //  }
        //}
      }
      else {
        this.setParentModel(this.returnNode ? node : node.id);
      }
    },
    clearSelection() {
      this.mod = '';
    },
    getParentModel() {
      if (!this.model.includes('.')) {
        return this.parent[this.model];
      }
      else {
        var arr = this.model.split('.');

        var aa = this.parent;

        for (var i = 0; i < arr.length; i++) {
          aa = aa[arr[i]];

          if (i == arr.length - 1) {
            return aa;
          }
        }
      }
    },
    setParentModel(id) {
      if (id == undefined) {
        this.parent[this.model] = '';
        return;
      }

      if (!this.model.includes('.')) {
        this.parent[this.model] = id;
      }
      else {
        var arr = this.model.split('.');

        var m = this.parent.$data;

        for (var i = 0; i < arr.length; i++) {
          m = m[arr[i]];

          if (i == arr.length - 2) {
            m[arr[i + 1]] = id;
            break;
          }
        }
      }
    },
    refreshMod(val) {
      this.mod = val;
    }
  }
}

